<template>
    <div
        class="sales-items masonry-items"
        v-if="crmProjects != null"
        v-masonry
        :column-width="386"
        :gutter="20"
        stagger="0s"
        transition-duration="0s"
        item-selector=".sale-item"
        id="masonryItems"
        :class="'sales-filter-city-active-' + salesFilterParams.cityActive"
    >
        <div
            v-masonry-tile
            class="sale-item"
            v-for="(item, index) in projectItems"
            :data-name="item.project_name.slug"
            :data-style="item.project_card_style"
            :data-theme="item.project_card_style_type"
            :key="item.project_name.slug"
            :class="{
                'sale-item-city-active-all': salesFilterParams.cityActive == 'all',
                animate: cardAnimate,
            }"
        >
            <div class="inner">
                <component
                    :is="getComponentType(item)"
                    :href="getHref(item)"
                    class="link-to-page"
                    :target="item.project_type_soon != 'true' ? '_blank' : false"
                    :to="getRouterTo(item)"
                >
                    <!-- Image -->
                    <div class="item-img">
                        <div class="img-in" :style="'background-image: url(' + item.project_img + ')'"></div>
                        <div class="item-sales-info">
                            <div
                                class="project-theme-list-items"
                                v-if="item.project_them_list != null && item.project_them_list.length > 0"
                            >
                                <ul>
                                    <li
                                        v-for="(list, idx) in item.project_them_list.slice(0, 1)"
                                        :key="idx"
                                        :style="'background-color:' + list.bg"
                                    >
                                        <p :style="'color:' + list.color" v-html="list.desc"></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="item-content">
                        <div class="content-in">

                            <!-- Logo + Favorite -->
                            <div class="item-logo-word">
                                <strong v-html="getCorrectLogoWord(item.project_name.slug)"></strong>
                                <div
                                    class="btn-to-favorite"
                                    v-if="cardAnimate"
                                    :class="{
                                        bank_promo: item.project_stie_bank_logo_init == 'true',
                                        'bank-promo-ob': item.project_stie_bank_ob_logo_init == 'true',
                                    }"
                                >
                                    <a
                                        href="#"
                                        @click.prevent="sendToFavorite(item.project_name.name), checkerClass($event)"
                                        :class="{ active: checkProjectFavorite(item.project_name.name) }"
                                        class="favorite-link"
                                    >
                                        <svgIcon name="star-sales" class="icon-star" />
                                    </a>
                                </div>
                            </div>

                            <!-- Price block: обычные проекты -->
                            <div
                                class="price-container"
                                v-if="isRegularProject(item) && item.project_type_soon != null && item.project_type_soon != 'true'"
                            >
                                <div
                                    class="price-info"
                                    v-if="
                                        item.crm_code != null &&
                                        item.crm_code != '' &&
                                        item.project_stie_shablon_price_flats_init == 'true' &&
                                        crmProjects != null &&
                                        getCRMprojectInfo(item.crm_code, 'price', item.project_name.slug) != false
                                    "
                                >
                                    <div class="price-num">
                                        <p v-if="globalLang == ''"><span>от</span> {{ getCRMprojectInfo(item.crm_code, 'price') }} <span>тг/м²</span></p>
                                        <p v-if="globalLang == 'kz/'">{{ getCRMprojectInfo(item.crm_code, 'price') }}<span> тг/м² бастап</span></p>
                                        <p v-if="globalLang == 'en/'"><span>from</span> {{ getCRMprojectInfo(item.crm_code, 'price') }} <span>tg/м²</span></p>
                                    </div>
                                    <a
                                        href="#"
                                        @click.prevent="navigationToFlatsFilter(item.crm_code)"
                                        v-if="item.project_stie_flats_filter_init == 'true'"
                                    >
                                        <span v-if="globalLang == ''">КВАРТИРЫ</span>
                                        <span v-if="globalLang == 'kz/'">ПӘТЕРЛЕР</span>
                                        <span v-if="globalLang == 'en/'">Layouts</span>
                                        <svgIcon name="arrow-go-right" />
                                    </a>
                                </div>
                                <div class="price-info-not-allowed" v-else>
                                    <div class="price-num">
                                        <p v-if="globalLang == ''">Цена по запросу</p>
                                        <p v-if="globalLang == 'kz/'">Cұраныс бойынша</p>
                                        <p v-if="globalLang == 'en/'">Price on request</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Price block: LDM проекты (lmgold / vesper / parkville) -->
                            <div
                                class="price-container"
                                v-if="isLdmProject(item) && item.project_type_soon != null && item.project_type_soon != 'true'"
                            >
                                <div class="price-info">
                                    <div class="price-num" v-if="ldmPrices[item.project_name.slug] != null">
                                        <p v-if="globalLang == ''"><span>от</span> {{ ldmPrices[item.project_name.slug] }} <span>тг/м²</span></p>
                                        <p v-if="globalLang == 'kz/'">{{ ldmPrices[item.project_name.slug] }}<span> тг/м² бастап</span></p>
                                        <p v-if="globalLang == 'en/'"><span>from</span> {{ ldmPrices[item.project_name.slug] }} <span>tg/м²</span></p>
                                    </div>
                                </div>
                            </div>

                            <!-- Soon block -->
                            <div class="form-soon-container" v-if="item.project_type_soon != null && item.project_type_soon == 'true'">
                                <div class="btn-to-login">
                                    <a href="#" @click.prevent="openForm(item, item.project_name.slug)">
                                        <span v-if="globalLang == ''">Зарегистрироваться</span>
                                        <span v-if="globalLang == 'kz/'">Тіркелу</span>
                                        <span v-if="globalLang == 'en/'">Register</span>
                                        <svgIcon name="arrow-go-right" />
                                    </a>
                                </div>
                            </div>

                            <!-- Address + Bank logos -->
                            <div class="adress-container">
                                <div class="adres" :class="getClass(item)">
                                    <div v-html="item.project_adres"></div>
                                </div>
                                <div class="banks-logos">
                                    <div class="logo-item" v-if="item.project_stie_bank_ob_logo_init == 'true'"><img :src="setup.logo_ob_bank" alt="" /></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_logo_init == 'true'"><img :src="setup.logo_cc_bank" alt="" /></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_halyk_logo_init == 'true'"><img :src="setup.logo_halyk_bank" alt="" /></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_altyn_logo_init == 'true'"><img :src="setup.logo_altyn_bank" alt="" /></div>
                                    <div class="logo-item" v-if="item.project_stie_bank_rbk_logo_init == 'true'"><img :src="setup.logo_rbk_bank" alt="" /></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </component>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import svgIcon from '@/components/partials/SvgIcon.vue';

const LDM_SLUGS = ['lmgold', 'vesper', 'parkville', 'benelux'];

export default {
    name: 'sale-item',

    components: {
        svgIcon,
    },

    data() {
        return {
            globalLang: window.GlobalLang,
            routerName: this.$router.history.current.name,
            isMobile: false,
            // Хранит цены LDM-проектов по slug: { lmgold: '450.000', vesper: null, ... }
            ldmPrices: {},
        };
    },

    computed: {
        ...mapGetters({
            projectItems: 'loadProjectItems',
            cardAnimate: 'loadCardAnimateStatus',
            projectItemsDefault: 'loadProjectItemsDefault',
            projectFilterCity: 'loadProjectItemsFilterCity',
            crmProjects: 'loadCrmProjects',
            setup: 'loadPageSetUp',
            salesFilterParams: 'loadSalesFilterParams',
            isMobileChecker: 'loadIsMobileChecker',
        }),
    },

    watch: {
        // Когда projectItems загрузились — подтягиваем LDM-цены один раз
        projectItems: {
            immediate: true,
            handler(items) {
                if (!items || !items.length) return;
                items.forEach((item) => {
                    if (
                        this.isLdmProject(item) &&
                        item.crm_code &&
                        !(item.project_name.slug in this.ldmPrices)
                    ) {
                        this.fetchLdmPrice(item.crm_code, item.project_name.slug);
                    }
                });
            },
        },
    },

    methods: {
        /* ─── Helpers для шаблона ─────────────────────────────────── */

        isLdmProject(item) {
            return LDM_SLUGS.includes(item.project_name.slug);
        },

        isRegularProject(item) {
            return !LDM_SLUGS.includes(item.project_name.slug);
        },

        getComponentType(item) {
            if (item.project_type_soon == 'true' && item.project_site_type != 'promo') return 'span';
            if (item.project_type_soon == 'soon' && item.project_site_type == 'promo') return 'router-link';
            return 'a';
        },

        getHref(item) {
            if (item.project_type_soon == 'true' && item.project_site_type == 'promo') {
                return '/sales/promo/' + item.project_name.slug;
            }
            return ((item.project_site_in && item.project_site_in.link) ? item.project_site_in.link + '?utm_source=sales.bazis.kz&utm_medium=complex&utm_campaign=web' : '');
        },

        getRouterTo(item) {
            if (item.project_type_soon == 'true' && item.project_site_type == 'promo') {
                return '/sales/promo/' + item.project_name.slug;
            }
            return false;
        },

        /* ─── Цены LDM (один запрос на проект при монтировании) ───── */

        fetchLdmPrice(id, slug) {
            const complexCodes = id.split(', ');

            axios
                .post(window.CRMProxy + '/v1/complexes', { complexCodes })
                .then(({ data }) => {
                    if (data.data && data.data.length > 0) {
                        const validPrices = data.data
                            .map((c) => c.minMeterPrice)
                            .filter((v) => v !== null && v !== undefined)
                            .map(Number);

                        const minPrice = validPrices.length > 0 ? Math.min(...validPrices) : null;
                        this.$set(this.ldmPrices, slug, minPrice ? this.getNumber(minPrice) : null);
                    } else {
                        this.$set(this.ldmPrices, slug, null);
                        console.warn('fetchLdmPrice: нет данных для', slug);
                    }
                })
                .catch((error) => {
                    this.$set(this.ldmPrices, slug, null);
                    console.error('fetchLdmPrice error:', error && error.response ? error.response.data : error, error && error.response ? error.response.status : '');
                });
        },

        /* ─── CRM (обычные проекты) ───────────────────────────────── */

        getCRMprojectInfo(id, key) {
            if (!id || !this.crmProjects) return false;

            const match = this.crmProjects.find((item) => item.code == id);
            if (!match) return false;

            if (key === 'price') {
                return match.minMeterPrice ? this.getNumber(match.minMeterPrice) : false;
            }
            return match.apartmentsQuantity || false;
        },

        /* ─── Форматирование числа ────────────────────────────────── */

        getNumber(n) {
            return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
        },

        /* ─── Избранное ───────────────────────────────────────────── */

        sendToFavorite(name) {
            let exist = localStorage.getItem('favorite_projects');
            exist = exist ? exist.split(',') : [];

            const idx = exist.indexOf(name);
            if (idx === -1) {
                exist.push(name);
            } else {
                exist.splice(idx, 1);
            }

            localStorage.setItem('favorite_projects', exist);
            this.$store.commit('setFavoriteCount', exist.length);
        },

        checkProjectFavorite(name) {
            const items = localStorage.getItem('favorite_projects');
            const arr = items ? items.split(',') : [];
            this.$store.commit('setFavoriteCount', arr.length);
            return arr.includes(name);
        },

        checkerClass(event) {
            event.currentTarget.classList.toggle('active');

            if (this.routerName === 'favorite-projects') {
                const favorite = (localStorage.getItem('favorite_projects') || '').split(',').filter(Boolean);
                const favoriteItems = this.projectItemsDefault.filter((item) =>
                    favorite.includes(item.project_name.name)
                );

                this.$store.commit('cardAnimateSet', false);
                setTimeout(() => {
                    this.$store.commit('filterProjectsItems', favoriteItems);
                    this.$store.commit('cardAnimateSet', true);
                }, 50);
            }
        },

        /* ─── Навигация ───────────────────────────────────────────── */

        checkForSite(name, arr) {
            if (arr.project_site_type === 'link') {
                window.open(arr.project_site_in.link, '_blank');
            } else if (arr.project_site_type != null) {
                this.$router.push({ name: 'sales-app', params: { id: name } });
            }
        },

        openForm(arr, projectName) {
            if (projectName == 'aston-park') {
                window.open('https://astonpark.bazis.kz/?utm_source=sales.bazis.kz&utm_medium=complex&utm_campaign=web', '_blank');
            } else if (projectName == 'manifique') {
                window.open('https://manifique.bazis.kz/?utm_source=sales.bazis.kz&utm_medium=complex&utm_campaign=web', '_blank');
            } else {
                this.$store.commit('setDataToSignupModal', arr);
                this.$modal.show('form-modal-signup');
            }
        },

        navigationToFlatsFilter(code) {
            this.$router.push({ path: 'flats', query: { 'complex-code': code } });
        },

        /* ─── Логотип / отображаемое имя ─────────────────────────── */

        getCorrectLogoWord(word) {
            const map = {
                'orion-3': 'orion <span class="orion-word">III</span>',
                jazzkvartal: 'JAZZ KVARTAL',
                auezovcity: 'AUEZOV CITY',
                'auezov-city-pro': 'AUEZOV CITY PRO',
                'belyy-ostrov': 'БЕЛЫЙ ОСТРОВ',
                jandostar: 'JAN DOSTAR',
                lmgold: 'LANDMARK GOLD',
                grandmonaco: 'GRAND MONACO',
            };
            return map[word] || word.replace('-', ' ');
        },

        /* ─── CSS-класс для адреса (кол-во банков) ───────────────── */

        getClass(item) {
            const flags = [
                item.project_stie_bank_halyk_logo_init,
                item.project_stie_bank_logo_init,
                item.project_stie_bank_ob_logo_init,
                item.project_stie_bank_rbk_logo_init,
                item.project_stie_bank_altyn_logo_init,
            ];
            const count = flags.filter((f) => f === 'true').length;
            return count > 0 ? 'adres-type-' + count : 'adres-standart';
        },

        /* ─── Resize ──────────────────────────────────────────────── */

        handleResize() {
            this.isMobile = window.innerWidth < 767;
        },
    },

    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style lang="scss">
    @import '@/styles/components/sales/sale-item-new.scss';
    @import '@/styles/respond/sales/respond-sale-item-new.scss';
</style>